<div class="form-group row" [formGroup]="notificationSettingsForm" [loadingOverlay]="loading">
  <div class="col-md-12">
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Skip Onsite Blogging Approval Process and Email</label>
        <div class="col-md-6">
          <div>
            <shared-components-customchoice formControlName="skipOnsiteBloggingApproval"></shared-components-customchoice>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Skip Onsite Copy Approval Process and Email</label>
        <div class="col-md-6">
          <div>
            <shared-components-customchoice formControlName="skipOnsiteCopyApproval"></shared-components-customchoice>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-4 col-form-label">Skip Onsite Recommendation Approval Process and Email</label>
        <div class="col-md-6">
          <div>
            <shared-components-customchoice
              formControlName="skipOnsiteRecommendationApproval"></shared-components-customchoice>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4 col-form-label">
          Onboarding Scheduling Link
        </div>
        <div class="col-md-6">
          <input class="form-control" type="text" formControlName="onboardingSchedulingLink" lpValidationMsg>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-4 col-form-label">
          Scheduling Link
        </div>
        <div class="col-md-6">
          <input class="form-control" type="text" formControlName="schedulingLink" lpValidationMsg>
        </div>
      </div>
      <hr class="w-50 mx-auto my-5" />
      <div>
        <app-components-manager-partner-front-channel [partnerId]="partner.PartnerId">
        </app-components-manager-partner-front-channel>
      </div>
      <hr class="w-50 mx-auto my-5" />

      <div class="form-group row">
        <label class="col-md-4 col-form-label">Allow Text Messaging</label>
        <div class="col-md-6">
          <div>
            <shared-components-customchoice formControlName="allowsTextMessaging"></shared-components-customchoice>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <label class="col-md-4 col-form-label" for="textMessagingPhoneNumber">Text Messaging Number</label>
        <div class="col-md-6">
          <input
            formControlName="textMessagingPhoneNumber"
            disabled="true"
            class="form-control"/>
        </div>
      </div>
    </div>
</div>

<ng-template #provisionTextMessageNumberModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Provision Phone Number</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <span>This will provision a new toll-free number for partner: {{ partner.Name }}</span>
  </div>
  <div class="modal-footer">
    <button (click)="modal.dismiss()" class="btn btn-outline">Cancel</button>
    <button (click)="modal.close(true)" class="btn btn-primary">Confirm</button>
  </div>
</ng-template>
